import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import { chevronForward,  } from 'ionicons/icons';
import { loginRequest } from '../../store/actions';
import { withTranslation } from '../../lib/translate';
import Loading from '../../components/spinner';
import { Spacer, Title, Subtitle } from '../../components/common';
import './index.css';
import KioskCode from '../../components/kioskCode';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleInput(key, val) {
    this.setState({ [key]: val });
  }

  handleLogin() {
    const { code } = this.state;
    if (code.length === 6) {
      this.props.dispatch(
        loginRequest({
          code,
          useCode: true,
        }),
      );
    }
  }

  onCodeChange = (code) => {
    this.setState({ code });
  };
  render() {
    const { __, clientProfile } = this.props;
    const { code } = this.state;
    return (
      <Loading>
        <div style={{ height: '100%' }} className='grid-wrapper grid-justify-center grid-align-start large-padding text-centered'>
          <div className=' text-centered grid-wrapper grid-justify-center'>

            <Title className="block  large-title">{__('Log in')}</Title>
            <Spacer size={0} />
            <Subtitle className="block centered text-color">
              {__(
                'To login and earn loyalty, enter your one time code below.',
              )}
            </Subtitle>
            <Spacer size={3} />
            <KioskCode code={code} onCodeChange={this.onCodeChange} numDigits={6}></KioskCode>

            <Spacer size={3} />
          </div>
          <div>
            <IonButton
              expand='block'
              disabled={code.length < 6}
              onClick={() => this.handleLogin()}
              className="large-button"
            >
              {__('Login')}
              <IonIcon slot='end' icon={chevronForward} />
            </IonButton>
          </div>

        </div>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { auth, protectedReferrer } = state.profile;
  const { storedDeliveryAddress, storedPickUpPoint } = state.orders;
  const { navConfig, clientProfile } = state.common;
  return {
    auth,
    protectedReferrer,
    storedDeliveryAddress,
    storedPickUpPoint,
    navConfig,
    clientProfile,
  };
};

export default connect(stateToProps)(withTranslation(Login));
